import { addPageAction, getNewRelicName } from './new_relic.js';

export const toggleImages = (isChecked, event = null) => {
  const images = document.querySelectorAll('af-family-card :is(af-frozen-img, img[slot$="sample"])');
  if (!images) {
    return;
  }

  if (event) {
    addPageAction(getNewRelicName('hide-images', event), { isChecked: isChecked });
  }

  images.forEach(image => image.setAttribute('slot', isChecked ? 'sample' : 'hidden-sample'));
};

export const setTextView = () => {
  const imagesToggler = document.querySelector('af-images-toggler');
  if (!imagesToggler) {
    return;
  }

  imagesToggler.showImages = false;
  toggleImages(false);
};
